// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Xfzm","subheader":"ReorderModal_subheader__30AXB","listWrap":"ReorderModal_listWrap__2yzpI"};